import type { SpartanStretchPixelDirection } from '@/app/lcv/components/sections/spartan/shared/stretch-pixel/types';

export const SPARTAN_STRETCH_PIXEL_DEFAULT_DURATION_MS = 2000;

export const SPARTAN_STRETCH_PIXEL_DEFAULT_DELAY_MS = 0;

export const SPARTAN_STRETCH_PIXEL_DEFAULT_EASING =
  'cubic-bezier(0.45, 0, 0.55, 1)';

export const SPARTAN_STRETCH_PIXEL_DEFAULT_STRETCH = 6000;

export const SPARTAN_STRETCH_PIXEL_DEFAULT_DIRECTION: SpartanStretchPixelDirection =
  'ltr';

export const SPARTAN_STRETCH_PIXEL_DEFAULT_SIZES =
  '(min-width: 1536px) 1600px, 100vw';
